// extracted by mini-css-extract-plugin
module.exports = {"header":"BlockHeader_header__G410G"};